import { createGlobalStyle } from 'styled-components';

const FontsStyles = createGlobalStyle`
  @font-face {
    font-family: "SuisseIntl";
    src: url("/fonts/suisseIntl-regular.woff2") format("woff2");
    font-weight: 450;
    font-display: swap;
    font-style: normal;
  }

  @font-face {
    font-family: "SuisseIntl";
    src: url("/fonts/suisseIntl-regularitalic.woff2") format("woff2");
    font-weight: 450;
    font-display: swap;
    font-style: italic;
  }
  
  @font-face {
    font-family: "SuisseIntl";
    src: url("/fonts/suisseIntl-semibold.woff2") format("woff2");
    font-weight: 600;
    font-display: swap;
    font-style: normal;
  }
  
  @font-face {
    font-family: "SuisseIntl";
    src: url("/fonts/suisseIntl-semiboldItalic.woff2") format("woff2");
    font-weight: 600;
    font-display: swap;
    font-style: italic;
  }
`;

export { FontsStyles };
